export function handleError(): void {
  // eslint-disable-next-line no-console
  console.log('Service worker registration failed.');
}
